import { Drawer } from "antd";
import { useRef } from "react";

const AppDynamicFilterModal = ({
  open,
  onClose,
  fields = [],
  onSearch,
  onReset,
}) => {
  const inputRef = useRef(null);
  const appForm = useRef(null);

  const handleSearch = () => {
    let data = appForm?.current?.form?.current?.getData();
    if (onSearch) onSearch(data);
  };

  const handleReset = () => {
    appForm?.current?.form?.current?.reset();
    if (onReset) onReset({}, true);
    // onClose();
  };

  return (
    <Drawer
      title="Filters"
      placement="right"
      onClose={onClose}
      open={open}
      width={500}
    >
      <AppForm className="filter-fields" ref={appForm}>
        {fields.map((field) => {
          return (
            <div className="mb-4">
              <AppFloatingLabel {...field}>
                <AppInput ref={inputRef} {...field} labelpos="none"></AppInput>
              </AppFloatingLabel>
            </div>
          );
        })}
      </AppForm>

      <div className="filter_modal_footer_actions flex-row justify-content-end">
        <button
          className="btn filter_modal_clear_btn"
          type="button"
          onClick={handleReset}
        >
          Clear All
        </button>
        <button
          className="btn btn-primary bg_gradient"
          type="submit"
          onClick={handleSearch}
        >
          Apply Filters
        </button>
      </div>
    </Drawer>
  );
};

export default AppDynamicFilterModal;
